import React from 'react';



export const Support = ({ height="52px", width="36px",padding="12px",style=''})=> (
<svg className="icon_support_outline" role="presentation" aria-label="" padding={padding} viewBox="0 0 26 21" version="1.1" xmlns="http://www.w3.org/2000/svg">
<g id="Symbols" stroke="none" strokeWidth="1" fill="rgb(97, 56, 245)" fillRule="evenodd">
<g>
<path d="M14.94,6.75a5.43,5.43,0,0,1,5.55,4.92,5.18,5.18,0,0,1-1.41,3.91,5.27,5.27,0,0,1-3.88,1.67H3.5V13.2h0V11.33A4.6,4.6,0,0,1,8.12,6.75h6.82m0-1.5H8.12A6.1,6.1,0,0,0,2,11.33V14.7H2v4a0,0,0,0,0,0,0H15.2A6.78,6.78,0,0,0,22,11.58a7,7,0,0,0-7-6.33Z"/>

<path d="M11.2,12.39a1,1,0,0,1,.07-.4,1.51,1.51,0,0,1,.2-.35,2.61,2.61,0,0,1,.27-.31l.3-.26a5.8,5.8,0,0,0,.5-.46.67.67,0,0,0,.22-.48.6.6,0,0,0-.21-.46A.83.83,0,0,0,12,9.48a.93.93,0,0,0-.56.17,1.11,1.11,0,0,0-.35.46L10,9.77a2,2,0,0,1,.74-1A2.08,2.08,0,0,1,12,8.32a2.27,2.27,0,0,1,.72.12,2.35,2.35,0,0,1,.64.36,2,2,0,0,1,.46.57,1.52,1.52,0,0,1,.17.74,1.46,1.46,0,0,1-.11.62,1.7,1.7,0,0,1-.29.47,1.9,1.9,0,0,1-.38.37,4.28,4.28,0,0,1-.38.29,3.4,3.4,0,0,0-.33.29.41.41,0,0,0-.13.28v.72H11.2Zm0,3.06a.83.83,0,0,0,.58.23.81.81,0,0,0,.57-.23.79.79,0,0,0,0-1.13.81.81,0,0,0-.57-.23.83.83,0,0,0-.58.23.81.81,0,0,0,0,1.13Z"/>
</g>
</g>
</svg>
);
